import type { RouteRecordRaw } from "vue-router";

import { getRouteParamOrEmpty } from "../utils";

export const subscriptionsRoutes: RouteRecordRaw[] = [
  {
    path: "/anonymoustransaction",
    name: "anonymoustransaction",
    component: () =>
      import(
        /* webpackChunkName: "dashboard-anonymous-transaction" */ "../../components/subscriptions/AnonymousTransactionView.vue"
      ),
    meta: {
      titleKey: "pageTitle.anonymousTransaction",
      layout: "auth",
      viewGroup: "anonymoustransaction"
    }
  },
  {
    path: "/anonymoustransaction/status",
    name: "anonymoustransaction-status",
    component: () =>
      import(
        /* webpackChunkName: "dashboard-anonymous-transaction-status" */ "../../components/subscriptions/AnonymousTransactionStatusView.vue"
      ),
    meta: {
      titleKey: "pageTitle.anonymousTransactionStatus",
      layout: "auth",
      viewGroup: "anonymoustransaction-status"
    }
  },
  {
    path: "/subscriptions",
    name: "subscriptions",
    component: () =>
      import(/* webpackChunkName: "dashboard-subscriptions" */ "../../components/subscriptions/SubscriptionView.vue"),
    meta: { titleKey: "pageTitle.subscriptions", viewGroup: "subscriptions" }
  },
  {
    path: "/subscription/renew/:id",
    name: "subscription-renew",
    component: () =>
      import(/* webpackChunkName: "dashboard-subscriptions" */ "../../components/subscriptions/SubscriptionView.vue"),
    props: true,
    meta: { titleKey: "pageTitle.subscriptionRenew", viewGroup: "subscriptions" }
  },
  {
    path: "/subscription/purchase/:templateId",
    name: "subscription-purchase",
    component: () =>
      import(/* webpackChunkName: "dashboard-subscriptions" */ "../../components/subscriptions/SubscriptionView.vue"),
    props: route => ({
      templateId: getRouteParamOrEmpty(route, "templateId"),
      billableId: typeof route.query.billableId === "string" ? route.query.billableId : undefined
    }),
    meta: { titleKey: "pageTitle.purchaseSubscription", viewGroup: "subscriptions" }
  },
  {
    path: "/subscriptions/welcometemplatemanagerinvitation/:id",
    name: "template-manager-invitation",
    component: () =>
      import(
        /* webpackChunkName: "dashboard-invitations" */ "../../components/invitations/TemplateManagerInvitationView.vue"
      ),
    props: route => ({
      id: getRouteParamOrEmpty(route, "id"),
      autoAccept: route.query.accept === "true" || route.query.accept === "1"
    }),
    meta: {
      titleKey: "pageTitle.templateManagerInvitation",
      layout: "auth",
      resetScroll: true,
      viewGroup: "template-manager-invitation",
      viewGroupParams: ["id"]
    }
  },
  {
    path: "/subscriptions/shareduserinvitation/:id",
    name: "shared-user-invitation",
    component: () =>
      import(
        /* webpackChunkName: "dashboard-invitations" */ "../../components/invitations/SharedUserInvitationView.vue"
      ),
    props: route => ({
      id: getRouteParamOrEmpty(route, "id"),
      autoAccept: route.query.accept === "true" || route.query.accept === "1"
    }),
    meta: {
      titleKey: "pageTitle.sharedUserInvitation",
      layout: "auth",
      resetScroll: true,
      viewGroup: "shared-user-invitation",
      viewGroupParams: ["id"]
    }
  },
  {
    path: "/subscriptions/:id",
    name: "subscription-details",
    component: () =>
      import(/* webpackChunkName: "dashboard-subscriptions" */ "../../components/subscriptions/SubscriptionView.vue"),
    props: true,
    meta: { titleKey: "pageTitle.subscriptionDetails", viewGroup: "subscriptions" }
  },
  {
    path: "/subscriptions/shared/:id",
    name: "subscription-shared-details",
    component: () =>
      import(/* webpackChunkName: "dashboard-subscriptions" */ "../../components/subscriptions/SubscriptionView.vue"),
    props: true,
    meta: { titleKey: "pageTitle.sharedSubscriptionDetails", viewGroup: "subscriptions" }
  }
];
